import { render, staticRenderFns } from "./MotivoExclusao.vue?vue&type=template&id=6f4168d1&scoped=true"
import script from "./MotivoExclusao.vue?vue&type=script&lang=js"
export * from "./MotivoExclusao.vue?vue&type=script&lang=js"
import style0 from "./MotivoExclusao.vue?vue&type=style&index=0&id=6f4168d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4168d1",
  null
  
)

export default component.exports